export const requestTrackingPermissions = async () => {
  console.log(`Ad tracking status: N/A on web`)
}
